import MuiListItemIcon from '@mui/material/ListItemIcon';
import type { ReactNode } from 'react';

export interface ListItemIconProps {
  children?: ReactNode;
}

export function ListItemIcon({ children }: ListItemIconProps) {
  return <MuiListItemIcon>{children}</MuiListItemIcon>;
}
